module.exports = __webpack_public_path__ + "static/media/4ODA12.ab4be327.jpg";